"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBImage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var Container = styled_components_1.default('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: #fff;\n  overflow: hidden;\n  position: relative;\n\n  ", "\n  ", "\n  ", "\n\n  \n  width: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  max-height: ", ";\n  min-height: ", ";\n  height: ", ";\n"], ["\n  background: ", ";\n  color: #fff;\n  overflow: hidden;\n  position: relative;\n\n  ", "\n  ", "\n  ", "\n\n  \n  width: ",
    ";\n  max-width: ", ";\n  min-width: ", ";\n  max-height: ", ";\n  min-height: ", ";\n  height: ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.darkBlue;
}, function (_a) {
    var border = _a.border;
    return border && "border: " + border + ";";
}, function (_a) {
    var objectFit = _a.objectFit;
    return objectFit && "object-fit: " + objectFit + ";";
}, function (_a) {
    var borderRadius = _a.borderRadius;
    return borderRadius && "border-radius: " + borderRadius + ";";
}, function (_a) {
    var width = _a.width;
    return width ? (typeof width === 'string' ? width : width + "px") : '100%';
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return (maxWidth ? maxWidth + "px" : '100%');
}, function (_a) {
    var minWidth = _a.minWidth;
    return minWidth && minWidth + "px";
}, function (_a) {
    var maxHeight = _a.maxHeight;
    return (maxHeight ? maxHeight + "px" : '100%');
}, function (_a) {
    var minHeight = _a.minHeight;
    return minHeight && minHeight + "px";
}, function (_a) {
    var height = _a.height;
    return Number.isInteger(height) ? height + "px" : "" + height;
});
var StyledImage = styled_components_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"], ["\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n"])));
var MBImage = function (_a) {
    var src = _a.src, borderRadius = _a.borderRadius, border = _a.border, width = _a.width, height = _a.height, maxWidth = _a.maxWidth, minWidth = _a.minWidth, maxHeight = _a.maxHeight, minHeight = _a.minHeight, objectFit = _a.objectFit, onClick = _a.onClick;
    return (jsx_runtime_1.jsx(Container, __assign({ borderRadius: borderRadius, border: border, width: width, height: height, maxWidth: maxWidth, minWidth: minWidth, maxHeight: maxHeight, minHeight: minHeight, objectFit: objectFit, onClick: onClick }, { children: jsx_runtime_1.jsx(StyledImage, { src: src }, void 0) }), void 0));
};
exports.MBImage = MBImage;
var templateObject_1, templateObject_2;
//# sourceMappingURL=MBImage.js.map